interface JQuery {
  onResize(
    config: {
      /** Area in pixels allowed to be dragged within the element @default 10. */
      clickableSize?: number;
      /** Used to store the current size in localStorage for page reloads. */
      localStorageId?: string;
      /** Maximum size in pixels the elment is allowed to grow to. */
      maxSize?: number;
      /** Minimum size in pixels the elment is allowed to shrink to. */
      minSize?: number;
      /** Side of the element that can be dragged. */
      side: 'left' | 'right';
    }
  ): JQuery;
  offResize(): JQuery;
}

(function ($: JQueryStatic) {
  $.fn.onResize = function ({
    clickableSize = 10,
    localStorageId,
    maxSize,
    minSize,
    side
  }) {
    let size: null | number = null;
    if (localStorageId) {
      size = parseInt(localStorage.getItem(localStorageId) ?? '');
    }
    if (isNaN(size ?? NaN)) {
      size = minSize ?? 100;
    }

    const updateSize = () => {
      size = Math.min(maxSize ?? Infinity, Math.max(minSize ?? 0, size ?? 0));
      this.each((_, element) => {
        element.style.width = `${size}px`;
      });
    };

    let clickEvent: MouseEvent | null = null;
    let clickSize: number | null = null;
    const onMouseDown = function(this: HTMLElement, event: MouseEvent) {
      const distanceFromEdge = (side === 'left') ? (
        this.offsetWidth - event.offsetX
      ) : event.offsetX;
      if (distanceFromEdge <= clickableSize) {
        clickEvent = event;
        clickSize = size;
        document.addEventListener('mousemove', onResize, false);
      }
    };
    const onMouseUp = () => {
      document.removeEventListener('mousemove', onResize, false);
    };
    const onResize = (event: MouseEvent) => {
      size = clickSize! + ((side === 'left') ? (
        event.x - clickEvent!.x
      ) : (
        clickEvent!.x - event.x
      ));
      updateSize();
      if (localStorageId) {
        localStorage.setItem(localStorageId, size.toString());
      }
    };
    this.data('onResize', { onMouseDown, onMouseUp });

    updateSize();
    document.addEventListener('mouseup', onMouseUp);

    return this.each((_, element) => {
      element.addEventListener('mousedown', onMouseDown);
    });
  };

  $.fn.offResize = function (): JQuery {
    const { onMouseDown, onMouseUp } = this.data('onResize');

    document.removeEventListener('mouseup', onMouseUp);
    return this.each((_, element) => {
      element.removeEventListener('mousedown', onMouseDown);
    });
  };
})(jQuery);
